import React from "react";
import {
  Button,
  Dialog,
  Classes,
  Intent,
  H3,
  Radio,
  RadioGroup,
  ProgressBar
} from "@blueprintjs/core";

import { saveAs } from 'file-saver';
import i18n from "../../../i18n";
import i18next from "i18next";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { getExtension } from "../../../utils/mef";
import { GranularitySelect } from "../../Structure/GranularitySelector";

export default class ExportActivityReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      generating: false,
      format: "excel",
      progress: 0,
      filterSelection: {...props.filterSelection},
      granularityId: 0
    }
  }

  handleOpen = () => this.setState({ isOpen: true });
  handleClose = () => this.setState({ isOpen: false, useTallContent: false, generating: false });
  handleGenerate = () => {
    this.setState({ generating: true });
    authenticatedGetFetch(`/activity/exportreport?format=${this.state.format}&` + this.props.urlsearchparams + "&g=" + this.state.granularityId,
                          (data)=>{
                            saveAs(new Blob([data]), "ActivityReport-"
                              + new Date(this.props.fr).toLocaleDateString(i18next.language)
                              + "-"
                              + new Date(this.props.to).toLocaleDateString(i18next.language)
                            + `.${getExtension(this.state.format)}`);
                            this.setState({ generating: false, progress: 1});
                          }, undefined, undefined, undefined, true);
  }

  render() {
    return (
      <div>
        <Button onClick={this.handleOpen} icon="floppy-disk" text={i18n.t("export to excel")} />
        <Dialog onClose={this.handleClose} isOpen={this.state.isOpen} style={{ transition: 'none' }}>
          <div className={Classes.DIALOG_BODY}>
            <H3><Trans>export to excel</Trans></H3>
            {this.state.generating ? <ProgressBar value={this.state.progress / 6} /> : <div>
              <RadioGroup
                label={<Trans>export format</Trans>}
                onChange={(rad) => {
                  const filter = {...this.state.filterSelection};
                  this.setState({ format: rad.target.value }); 
                  this.setState({ filterSelection: {...filter, format: rad.target.value} }); 
                }}
                selectedValue={this.state.format}
              >
                <Radio label="Excel" value="excel" />
                <Radio label="CSV" value="csv" />
                <Radio label="HTML" value="html" />
              </RadioGroup>
              <GranularitySelect onSelect={(id) => this.setState({ granularityId: id })} selection={this.state.granularityId} />
            </div>}
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button icon='undo' intent={Intent.DANGER} onClick={this.handleClose}>
                  <Trans>cancel</Trans>
                </Button>
                <Button icon='download'
                  loading={this.state.generating}
                  onClick={this.handleGenerate}
                >
                  <Trans>download</Trans>
                </Button>
              </div>
            </div>
          </div>
        </Dialog >
      </div>
    )
  }
}
